module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Button', {
    attrs: {
      "size": "small",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleImportBtnClick
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('input', {
    ref: "uploadInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e5f9433","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xlsx-importer.vue
// module id = 111
// module chunks = 1